<template>
  <pt-adult-stock-table class="pt-adult-stock-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" :status="status">
  <slot/>
  </pt-adult-stock-table>
</template>

<script>
import PtAdultStockTable from './index'
export default {
  name: 'pt-adult-stock-table__withData',
  components: {
    'pt-adult-stock-table': PtAdultStockTable
  },
  data () {
    return {
      pageSize: 20,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  props: {
    status: {
      type: String,
      required: true
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    isFuzzy: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    status (val, old) {
      // this.currentParams = {}
      this.resetPage()
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params.pageable = {}
        if (params.page || params.page === 0) {
          params.pageable['page'] = params.page
        }
        params.pageable['size'] = this.pageSize
        if (!params.example) {
          params.example = {}
        }
        params.example.inStore = this.getStatus(this.status || this.$route.params.status)
        return params
      }
      return {
        example: { inStore: this.getStatus(this.status) },
        pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
      }
    },
    getStatus (val) {
      let params
      if (val === 'ALL') {
        params = null
      } else {
        params = val === 'in'
      }
      return params
    },
    getDataList (page, next) {
      let data = this.buildFilterParams(page, this.currentParams)
      let api = this.isFuzzy ? 'stockFuzzyQuery' : 'adultInventories'
      this.$store.dispatch(api, data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
